import React, { useContext, useEffect, useState, useRef } from 'react';
import { Input } from '@progress/kendo-react-inputs';
import VideoPreview, { youtube_parser } from '../../VideoPreview';
import DeleteFormItem from '../../DeleteFormItem';
import { LocalizationContext } from '../../../contexts';
import Uploader, { uploaderTypes } from '../../Uploader';
import PublishSwitch from '../publishSwitch';
import './index.scss';
import '../forms.scss';

export default function HeroVideo({ data, onUpdate, validator, settingsData = {}, ...rest }) {
  const emptyItem = useRef({ title: "", video_url: "", video_preview_url: "", image_preview_url: "", isPublish: false });
  const [compData, setCompData] = useState({});
  const [compDataWithoutLastUpdate, setCompDataWithoutLastUpdate] = useState({});
  //const [validateMode, setValidateMode] = useState(false);
  const [localization] = useContext(LocalizationContext);
  const { labels } = localization;

  validator.current = () => {
    return true;
  };

  useEffect(() => {
    const defaultData = { ...emptyItem.current };
    setCompData({ ...defaultData, ...data });
  }, [data]);

  useEffect(() => {
    let { last_update, ...newCompData } = compData;
    setCompDataWithoutLastUpdate(newCompData);
  }, [compData]);

  const handleDeleteClick = () => {
    const newCompData = { ...compData, ...emptyItem.current };
    setCompData(newCompData);
    onUpdate(newCompData);
  };

  const updateItem = (newData) => {
    const newCompData = { ...compData, ...newData };
    setCompData(newCompData);
    onUpdate(newCompData);
  }

  // const validateForm = () => {
  //   if (compDataWithoutLastUpdate && JSON.stringify(compDataWithoutLastUpdate) === JSON.stringify(emptyItem.current)) {
  //     setValidateMode(false);
  //   } else {
  //     const formNotValid = !compData.video_url || !compData.video_preview_url || !compData.image_preview_url;
  //     if (formNotValid) {
  //       setValidateMode(true);
  //       return false;
  //     }
  //   }
  //   return true;
  // }

  const canPublish = () => {
    if (!compData.title || !compData.video_url || !compData.video_preview_url || !compData.image_preview_url) {
      return false;
    }
    return true;
  };

  const isEmptyItem = () => {
    return JSON.stringify(compDataWithoutLastUpdate) === JSON.stringify(emptyItem.current)
  }

  const showRequired = (requiredField) => {
    return (!isEmptyItem() && !requiredField)
  }

  return (
    <React.Fragment>
      <div className="form-message">
        {labels.pagesManagement.forms.show_for_unidentified_only}
      </div>
      <div className="form-content">
        <div className="form-item">
          <div className="form-item__title">
            {compData?.title}  {!isEmptyItem() && <DeleteFormItem handleDeleteClick={handleDeleteClick} />}
          </div>
          <div className="form-field">
            <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_title}</label>
            <Input name={'title'} value={compData.title} onChange={({ value }) => updateItem({ title: value })}></Input>
            {showRequired(compData.title) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
          </div>
          <div className="form-field">
            <label className="form-field__label mandatory">{labels.pagesManagement.forms.upload_short_file}</label>
            <Uploader type={uploaderTypes.video} videoUrl={compData.video_preview_url} prefix={'heroVideo'} onChange={(file) => { updateItem({ video_preview_url: file }) }} />
            {showRequired(compData.video_preview_url) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
          </div>
          <div className="form-field">
            <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_youtube_link}</label>
            <Input name={'video_url'} value={compData.video_url} style={{ direction: 'ltr', textAlign: 'left' }} onChange={({ value }) => updateItem({ video_url: value })}></Input>
            <VideoPreview videoUrl={compData.video_url} />
            {showRequired(compData.video_url) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
          </div>
          <div className="form-field">
            <label className="form-field__label mandatory">{labels.pagesManagement.forms.add_mobile_image}</label>
            <Uploader type={uploaderTypes.image} imageUrl={compData.image_preview_url} prefix={'heroVideo'} onChange={(file) => { updateItem({ image_preview_url: file }) }} />
            {showRequired(compData.image_preview_url) && <div className="form-field__required">{labels.pagesManagement.forms.required}</div>}
          </div>
        </div>
        <PublishSwitch isPublish={compData?.isPublish} canPublish={canPublish()}
          updateItem={(event) => updateItem({ isPublish: event.target.value })} />
      </div>
    </React.Fragment>
  );
};